import { retriedWorkshopReviewSchema } from '@mio/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRef } from 'react';

import { apiRequest } from '@/shared/api/client';

export function useRetryWorkshopReview() {
  const client = useQueryClient();
  const requests = useRef(new Map<string, string>());
  return useMutation({
    retry: false,
    mutationFn: async ({ submissionId }: { attemptId: string; submissionId: string }) => {
      let key = requests.current.get(submissionId);
      if (!key) {
        key = crypto.randomUUID();
        requests.current.set(submissionId, key);
      }
      return apiRequest(
        `/workshop/submissions/${submissionId}/retry`,
        retriedWorkshopReviewSchema,
        {
          method: 'POST',
          body: { idempotencyKey: key },
        },
      );
    },
    onSuccess: (_result, { attemptId, submissionId }) => {
      requests.current.delete(submissionId);
      void client.invalidateQueries({ queryKey: ['workshop', 'history', attemptId] });
      void client.invalidateQueries({ queryKey: ['workshop', 'session'] });
    },
  });
}
